<template>
  <div id="wangEditor">
    <div class ref="editorElem" @keydown="textChange($event)" @keyup="textChange($event)"></div>
  </div>
</template>

<script>
import E from "wangeditor";
import { Message } from 'element-ui';
export default {
  name: "",
  props:['editInfo','placeholderText','editType'],
  data() {
    return {
      editor: null,
      editorContent: "",
      mgList:[
        {
          "title": "表情",
          "type": "image",
          "content": [
            {
              src: "https://file.boxuegu.com/img/emoji/wx.png?1",
              alt: "微笑"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/kq.png?1",
              alt: "哭泣"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/tst.png?1",
              alt: "吐舌头",
            },
            {
              src: "https://file.boxuegu.com/img/emoji/fd.png?1",
              alt: "奋斗"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/yun.png?1",
              alt: "晕"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/dk.png?1",
              alt: "大哭"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/jy.png?1",
              alt: "加油"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/hd.png?1",
              alt: "好的"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/hs.png?1",
              alt: "好色"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/sad.png?1",
              alt: "难过"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/jiaoji.png?1",
              alt: "焦急"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/hx.png?1",
              alt: "害羞"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/han.png?1",
              alt: "汗"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/sq.png?1",
              alt: "生气"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/dx.png?1",
              alt: "大笑"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/zh.png?1",
              alt: "祝贺"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/dy.png?1",
              alt: "得意"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/sx.png?1",
              alt: "委屈"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/jingya.png?1",
              alt: "疑问"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/hx1.png?1",
              alt: "坏笑"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/nolook.png?1",
              alt: "无所谓",
            },
            {
              src: "https://file.boxuegu.com/img/emoji/bk.png?1",
              alt: "抓狂"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/fd1.png?1",
              alt: "否定"
            },
            {
              src: "https://file.boxuegu.com/img/emoji/wrong.png?1",
              alt: "做错事",
            }
          ]
        }
      ],
      colors:[
        '#000000',
        '#ffffff',
        '#1c487f',
        '#4d80bf',
        '#c24f4a',
        '#8baa4a',
        '#25c48b',
        '#7b5ba1',
        '#46acc8',
        '#f9963b',
        '#F0F0F0',
        '#4F383D',
        'transparent',
    ]
    };
  },
  mounted() {
    this.editor = new E(this.$refs.editorElem);
    this.editor.config.placeholder = this.placeholderText || '请输入内容'
    this.editor.config.uploadImgShowBase64 = false; // base 64 存储图片
    this.editor.config.uploadImgServer = VUE_APP_BASE_PATH_ONLINE_APP + "/bxg/apiAttachment/uploadNew?sign=" + localStorage.getItem('sign'); // 配置服务器端地址
    this.editor.config.uploadImgHeaders = {} // 自定义 header
    this.editor.config.uploadFileName = "file"; // 后端接受上传文件的参数名
    this.editor.config.withCredentials = true
    this.editor.config.showFullScreen = false // 隐藏全屏
    this.editor.config.uploadImgMaxSize = 5 * 1024 * 1024; // 将图片大小限制为 2M
    this.editor.config.uploadImgMaxLength = 5; // 限制一次最多上传 5 张图片
    this.editor.config.uploadImgTimeout = 10000; // 设置超时时间
    // this.editor.config.pasteFilterStyle = false
    this.editor.config.uploadImgHooks = {
      // 图片上传并返回结果，但图片插入错误时触发
      fail: function (xhr, editor, result) {
        Message.error('上传失败')
      },
      success: function (xhr, editor, result) {
        // 图片上传并返回结果，图片插入成功之后触发
        Message.success('上传成功')
      },
      error: function (xhr, editor) {
          // 图片上传出错时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
      },
      customInsert: function (insertImg, result, editor) {
        // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
        // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

        // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
        var url = result.result.url
        insertImg(url)
      }
    }
    this.editor.config.customAlert = function (info) {
       Message.error(info)
    }
    this.editor.config.showLinkImg = false; // 隐藏上传网络图片
    this.editor.config.emotions = this.mgList
    this.editor.config.colors = this.colors
    this.editor.config.onchangeTimeout = 0
    this.editor.config.onchange = html => {
      this.editorContent = html;
      this.$emit("editorChange", this.editorContent); // 把这个html通过catchData的方法传入父组件
    };
    this.editor.config.onblur = html => {
      this.editorContent = html;
      this.$emit("editorChange", this.editorContent); // 把这个html通过catchData的方法传入父组件
    };
    if(this.editType == 'QA'){
      this.editor.config.menus = [
        // 菜单配置
        "bold", // 粗体
        "italic", // 斜体
        "link", // 插入链接
        "list", // 列表
        "quote", // 引用
        "image", // 插入图片
        "code", // 插入代码
      ];
    }else{
      this.editor.config.menus = [
        // 菜单配置
        // 'head', // 标题
        "bold", // 粗体
        // "fontSize", // 字号
        // 'fontName', // 字体
        "italic", // 斜体
        // 'underline', // 下划线
        // 'strikeThrough', // 删除线
        "foreColor", // 文字颜色
        'backColor', // 背景颜色
        "link", // 插入链接
        "list", // 列表
        'justify', // 对齐方式
        // 'quote', // 引用
        "emoticon", // 表情
        "image", // 插入图片
        // 'table', // 表格
        'code', // 插入代码
        // 'undo', // 撤销
        // 'redo' // 重复
      ];
    }
    this.editor.create();
    if(this.editInfo) this.editor.txt.html(this.editInfo);
  },
  methods:{
    textChange(e){
      e.stopPropagation()
    },
    clearContent(){
      this.editor.txt.html("");
    },
    setEditInfo(val){
      this.$nextTick(()=>{
        this.editor.txt.html(val);
      })
    }
  },
  watch:{
    editInfo(val){
      this.editor.txt.html(val);
    }
  }
};
</script>

<style lang="less" scoped>
#wangEditor{
  width: 100%;
  height: 100%;
  overflow: hidden;
  >div{
    width: 100%;
    height: 100%;
  }
}
/deep/ .w-e-text-container{
  height: 100% !important;
}
/deep/ .w-e-emoticon-container .w-e-item{
  
  padding:0;
  img{
    width: 34px;
    height: 26px;
  }
}
::v-deep i {
  font-style: italic !important;
}
</style>